<template>
  <div :class="['topic_item']" :style="index == 0 ? 'padding:0 .75rem .75rem .75rem' : 'padding:.75rem'" v-if="isItem">
    <div :class="['title_box', isSdk && 'pointer_none']" v-if="isShowTitle" @click="toPageHome">
      <s-image width="1.9rem" height="1.9rem" borderRadius="50%"
        :src="item.customer_info && item.customer_info.avatar || item.game_info.icon" mode="scaleToFill" />
      <div class="text_box">
        <div class="title">
          <span>{{ item.customer_info.nickname || item.game_info.name }}</span>
          <img v-if="item.is_official||item.official_state" class="official" src="@/assets/image/shequ/off.png" />
          <img v-if="item.customer_info && item.customer_info.nickname_icon" class="user_tag"
            :src="item.customer_info && item.customer_info.nickname_icon" />
        </div>
        <div class="desc" v-if="item.publish_time !== ''">
          {{ this.$formatPostTime(item.publish_time) }}
        </div>
      </div>
    </div>
    <div class="topic_box" @click="goTopicDetail">
      <div class="game_title" v-if="!isShowTitle">
        <div class="name"> {{ item.game_info.name }}<span v-if="item.publish_time !== ''">·{{
          this.$formatPostTime(item.publish_time) }}</span></div>
        <div class="tag" :class="item.article_status == '未通过' ? 'tag' : 'alTag'"
          v-if="item.article_status != '已发布' && !isShowTitle && item.article_status">
          {{ item.article_status }}</div>
      </div>
      <div class="title">{{ item.title }}</div>
      <div class="desc"><div v-html="content"></div>  </div>
    </div>
    <div :id="`topic_video${item.id}`" class="topic_video" :class="{ playing: isPlay }" v-if="videoUrl">
      <div class="video_img" v-show="!isPlay" @click="play" style="width: 100%;height: 100%;">
        <s-image style="width: 100%;height: 100%;" borderRadius=".25rem" :src="videoimg" mode="aspectFill" />
      </div>
      <video ref="video" :src="videoUrl" :controls="isPlay" playsinline webkit-playsinline x5-playsinline
        x5-video-player-type="h5" x5-video-player-fullscreen="false" preload="metadata" :poster="videoimg"
        style="width:100%;height:100%;border:.05rem solid #fff;background: #000;" @loadedmetadata="onVideoLoadedMetadata" />
    </div>
    <div class="tpoic_img" v-else-if="imgList.length > 1">
      <div
        :class="['img_box', imgList.length == 1 && 'one', imgList.length == 2 && 'two', imgList.length == 3 && 'three']">
        <s-image v-for="item, i in imgList" :key="i" class="s_image1" :src="item" mode="aspectFill"
          :openImg="{ imgs: imgList, i }" />
      </div>
    </div>
    <div class="tpoic_img" v-else-if="imgList.length == 1&&isheightFix">
      <div :class="['img_box', 'one']">
        <s-image v-for="item, i in imgList" :key="i" class="s_image1" :src="item"
          mode="heightFix" :openImg="{ imgs: imgList, i }" />
      </div>
    </div>
    <div class="tpoic_img" v-else-if="imgList.length == 1&&!isheightFix">
      <div :class="['img_box', 'one']">
        <s-image v-for="item, i in imgList" :key="i" class="s_image1" :src="item"
          mode="widthFix" :openImg="{ imgs: imgList, i }" />
      </div>
    </div>
    <div class="topice_btn" v-if="isBtn">
      <div class="btn" @click="toShare">
        <img src="@/assets/image/shequ/fx1.png" />
        <span>{{ this.$getTopicNumber(item.share_num) }}</span>
      </div>
      <div class="btn" @click="goTopicDetail">
        <img src="@/assets/image/shequ/pl.png" />
        <span>{{ this.$getTopicNumber(item.comment_num) }}</span>
      </div>
      <div class="btn" @click="todz">
        <DzJSON :isLike="isLike" ref="lottie" :width="'1rem'" :height="'1rem'"></DzJSON>
        <span style="margin-left: .15rem;">{{ this.$getTopicNumber(item.like_num) }}</span>
      </div>
    </div>
    <!-- <share-pop @jubaoTopic="jubaoTopic" @deleteTopic="deleteTopic" :isTopic="true" ref="sharePop"></share-pop> -->
    <!-- <auditFailePop :reason="item.reason" ref="openpop" :extend_id='item.id' :game_id="item.game_id">
    </auditFailePop> -->
  </div>
</template>

<script>
import DzJSON from '../../pages/community/components/dzJSON.vue';
// import auditFailePop from '../auditfiled-pop/auditFailedPop.vue'
export default {
  name: 'UniMailiangTopicItem',
  components: {
    // auditFailePop,
    DzJSON,
  },
  props: {
    isShowTitle: {
      type: Boolean,
      default: true
    }, //他人主页、个人主页
    item: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      default: 1
    },
    pageTop: {
      type: Number,
      default: 0
    },
    hideToTopDistance: {
      type: Number,
      default: 0
    },
    isVideo:{
      type: Boolean,
      default: true
    },
    isBtn:{
      type: Boolean,
      default: true
    },
    isSdk:{
      type: Boolean,
      default: false
    },
    sdkpage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imgList: [],
      content: this.item.desc,
      videoUrl: '',
      videoimg: '',
      isPlay: false,
      isLike: false,
      isItem: true,
      isheightFix: true,
      videoVisibilityObserver: null,
      lastVideoTime: 0,
      shouldPlayWhenReady: false,
      rafVisibilityCheckId: 0,
      resumeAfterTopHide: false
    };
  },

  created() {
    const attachments = Array.isArray(this.item.attachments) ? this.item.attachments : []
    attachments.forEach((item) => {
      if (item.type == 1) {
        this.imgList.push(item.url);
      } else if (item.type == 2) {
        if (!this.videoUrl) {
          this.videoUrl = item.url;
          this.videoimg = item.cover;
        }
      }
    });
    this.imgList = this.imgList.slice(0, 3);
    if(this.item.cover_image){
      this.imgList = [this.item.cover_image]
    }
    if(this.content.length > 68) {
      this.content = this.content.slice(0,68) + '...' + `<span
          style="color: #1D1D1D;padding-left: .5rem;">全文</span>`
    }
  },
  mounted() {
    if(this.item.is_like == 1) this.isLike = true
    if(!this.item.game_id) {
      this.item.game_info = {
        icon: require('@/assets/image/icon/33.png'),
        name: '39官方'
      }
    }
    if (this.videoUrl && this.isVideo) {
      this.initVideoAutoControl()
    }
  },
  beforeDestroy() {
    this.teardownVideoAutoControl()
  },
  methods: {
    initVideoAutoControl() {
      this.teardownVideoAutoControl()
      const el = document.getElementById(`topic_video${this.item.id}`)
      if (!el) return

      if (typeof IntersectionObserver !== 'undefined') {
        this.videoVisibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries && entries[0]
          if (!entry) return
          this.handleVideoVisibility(entry.intersectionRatio)
        }, {
          root: null,
          threshold: [0, 0.01, 0.99, 1]
        })
        this.videoVisibilityObserver.observe(el)
        return
      }

      const onScrollOrResize = () => {
        if (this.rafVisibilityCheckId) return
        this.rafVisibilityCheckId = requestAnimationFrame(() => {
          this.rafVisibilityCheckId = 0
          this.checkVideoVisibilityFallback()
        })
      }
      window.addEventListener('scroll', onScrollOrResize, true)
      window.addEventListener('resize', onScrollOrResize, true)
      this._topicVideoOnScrollOrResize = onScrollOrResize
      this.checkVideoVisibilityFallback()
    },
    teardownVideoAutoControl() {
      this.shouldPlayWhenReady = false
      this.pauseVideo()

      if (this.videoVisibilityObserver) {
        this.videoVisibilityObserver.disconnect()
        this.videoVisibilityObserver = null
      }

      if (this._topicVideoOnScrollOrResize) {
        window.removeEventListener('scroll', this._topicVideoOnScrollOrResize, true)
        window.removeEventListener('resize', this._topicVideoOnScrollOrResize, true)
        this._topicVideoOnScrollOrResize = null
      }

      if (this.rafVisibilityCheckId) {
        cancelAnimationFrame(this.rafVisibilityCheckId)
        this.rafVisibilityCheckId = 0
      }
    },
    checkVideoVisibilityFallback() {
      const el = document.getElementById(`topic_video${this.item.id}`)
      if (!el) return
      const rect = el.getBoundingClientRect()
      const vw = window.innerWidth || document.documentElement.clientWidth
      const vh = window.innerHeight || document.documentElement.clientHeight
      const visibleWidth = Math.max(0, Math.min(rect.right, vw) - Math.max(rect.left, 0))
      const visibleHeight = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0))
      const elementWidth = rect.width || Math.max(1, el.offsetWidth || 1)
      const elementHeight = rect.height || Math.max(1, el.offsetHeight || 1)
      const ratio = (visibleWidth * visibleHeight) / (elementWidth * elementHeight)
      this.handleVideoVisibility(Math.max(0, Math.min(1, ratio)))
    },
    handleVideoVisibility(ratio) {
      if (!this.videoUrl || !this.isVideo) return
      const playMinRatio = 0.99

      if (ratio >= playMinRatio) {
        if (this.isWithinTopDistance()) {
          this.shouldPlayWhenReady = false
          this.resumeAfterTopHide = true
          this.pauseVideo()
          this.isPlay = false
          return
        }
        this.shouldPlayWhenReady = true
        if (!this.isPlay) {
          this.isPlay = true
          this.$nextTick(() => {
            if (this.shouldPlayWhenReady) this.playVideo()
          })
          return
        }
        this.playVideo()
        return
      }

      this.shouldPlayWhenReady = false
      this.pauseVideo()
      this.isPlay = false
    },
    isWithinTopDistance() {
      if (!this.hideToTopDistance || this.hideToTopDistance <= 0) return false
      const el = document.getElementById(`topic_video${this.item.id}`)
      if (!el || !el.getBoundingClientRect) return false
      const rect = el.getBoundingClientRect()
      return rect.top <= this.hideToTopDistance
    },
    isFullyVisibleInViewport() {
      const el = document.getElementById(`topic_video${this.item.id}`)
      if (!el || !el.getBoundingClientRect) return false
      const rect = el.getBoundingClientRect()
      const vw = window.innerWidth || document.documentElement.clientWidth
      const vh = window.innerHeight || document.documentElement.clientHeight
      return rect.top >= -1 && rect.left >= -1 && rect.bottom <= vh + 1 && rect.right <= vw + 1
    },
    onVideoLoadedMetadata() {
      const video = this.getVideoEl()
      if (!video) return
      if (this.lastVideoTime > 0 && Math.abs(video.currentTime - this.lastVideoTime) > 0.2) {
        try {
          video.currentTime = this.lastVideoTime
        } catch (e) {}
      }
      if (this.shouldPlayWhenReady) {
        this.playVideo()
      }
    },
    getVideoEl() {
      return this.$refs.video || null
    },
    playVideo() {
      if (!this.isPlay) return
      const video = this.getVideoEl()
      if (!video) return

      this.resumeAfterTopHide = false
      if (this.lastVideoTime > 0 && Math.abs(video.currentTime - this.lastVideoTime) > 0.2) {
        try {
          video.currentTime = this.lastVideoTime
        } catch (e) {}
      }
      const ret = video.play && video.play()
      if (ret && typeof ret.catch === 'function') {
        ret.catch(() => {
          try {
            video.muted = true
          } catch (e) {}
          const r2 = video.play && video.play()
          if (r2 && typeof r2.catch === 'function') r2.catch(() => {})
        })
      }
    },
    pauseVideo() {
      const video = this.getVideoEl()
      if (!video) return
      try {
        this.lastVideoTime = video.currentTime || 0
      } catch (e) {
        this.lastVideoTime = 0
      }
      if (video.pause) video.pause()
    },
    toShare() {
      this.$share.show({
        flag: true,
        isTopic: true,
        customer_id: this.item.customer_id,
        deleteTopic: this.deleteTopic,
        id: this.item.id,
        isJb: this.item.is_official,
        scene: 2
      })
    },
    // 删除帖子
    deleteTopic() {
      this.$emit('deleteTopic', this.item.id)
      this.isItem = false
      // this.$ajax('/article/deleteArticle', {
      //   id: this.item.id
      // }).then(rs => {
      //   if (rs.code == 200) {
      //     this.$toast(rs.msg)
      //     this.$emit('deleteTopic', this.item.id)
      //     this.isItem = false
      //     this.$share.show({})
      //   } else {
      //     this.$toast(rs.msg)
      //   }
      // })
    },
    // 举报帖子
    jubaoTopic() {
      this.$router.push({
        path: '/pages/complaint/complaint?type=1&target_id=' + this.item.id
      })
    },
    //去他人主页
    toPageHome() {
      if (this.item.is_official) {
        this.$router.push({
          path: '/pages/index/gamedetail/gamedetail?id=' + this.item.game_id
        })
      } else {
        this.$router.push({
          path: '/pages/user/homePageNew/index?customer_id=' + this.item.customer_id
        })
      }
    },
    // 点赞
    todz() {
      const url = this.isLike ? '/article/cancelArticleLike' : '/article/articleLike'
      this.$ajax(url, {
        article_id: this.item.id
      }).then(rs => {
        if (rs.code == 200) {
          this.isLike = !this.isLike
          if (this.isLike) {
            this.item.like_num++
          } else {
            if(this.item.like_num > 0) this.item.like_num--
          }
          if(rs.data.gift_id) this.$store.commit('popup/setPagePopupData', {
            showTopicWin: true,
            data: rs.data
          })
        } else {
          this.$toast(rs.msg)
        }
      })
    },
    goTopicDetail() {
      if(this.sdkpage){
        this.$router.push({
          path: '/pages/community/pages/topicDetail?id=' + this.item.id + '&sdkpage=' + this.sdkpage
        })
        return
      }
      if (this.item.article_status == '未通过') {
        this.$refs.openpop.doOpen()
        return
      } else {
        this.$router.push({
          path: '/pages/community/pages/topicDetail?id=' + this.item.id
        })
      }
    },
    // 播放视频
    play() {
      this.shouldPlayWhenReady = true
      this.isPlay = true
      this.$nextTick(() => {
        if (this.shouldPlayWhenReady) this.playVideo()
      })
    },
  },

  watch: {
    // item: {
    //   handler(val) {
    //     if (val) {
    //       if(!this.item.game_id) {
    //         this.item.game_info = {
    //           icon: require('@/assets/image/icon/33.png'),
    //           name: '39官方'
    //         }
    //       }
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // },
    isVideo:{
      handler(val) {
        if(!val){
          this.teardownVideoAutoControl()
          this.isPlay = false
        } else {
          if (this.videoUrl) {
            this.initVideoAutoControl()
          }
        }
      },
      immediate: true,
      deep: true
    },
    pageTop: {
      handler(val) {
        if (!this.videoUrl || !this.isVideo) return
        if (this.isPlay) {
          if (this.isWithinTopDistance()) {
            this.shouldPlayWhenReady = false
            this.resumeAfterTopHide = true
            this.pauseVideo()
            this.isPlay = false
          }
          return
        }

        if (this.resumeAfterTopHide && !this.isWithinTopDistance() && this.isFullyVisibleInViewport()) {
          this.shouldPlayWhenReady = true
          this.isPlay = true
          this.$nextTick(() => {
            if (this.shouldPlayWhenReady && this.isPlay) this.playVideo()
          })
        }
      },
      immediate: true,
      deep: true
    },
    '$store.state.community.deleteId': {
      handler(val) {
        // if (val.includes(this.item.id)) {
        //   this.isItem = false
        // }
      },
      immediate: true,
      deep: true
    },
    '$store.state.community.topicDetail': {
      handler(val) {
        if (val) {
            let item = val
            if (item.id == this.item.id) {
              this.item.isLike = item.is_like == 1 ? true : false;
              this.item.like_num = item.like_num;
              this.isLike = item.is_like == 1 ? true : false;
              if (this.isLike) {
                this.$refs.lottie.play();
              } else {
                this.$refs.lottie.goToAndStop(0);
              }
            }
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
// .kuangzi {
// 	border: .05rem solid red;
// }
.topic_item {
  background: #fff;
  border-radius: .5rem;
  border-bottom: .4rem solid #f8f8f8;
  .title_box {
    display: flex;
    align-items: center;
    margin-bottom: .5rem;
    .text_box {
      margin-left: .5rem;
      .title {
        display: flex;
        align-items: center;
        span {
          font-size: .7rem;
          font-weight: 700;
          color: #1D1D1D;
        }
        .official {
          width: .8rem;
          height: .8rem;
          margin-left: .25rem;
        }
        .user_tag {
          height: .8rem;
          margin-left: .25rem;
        }
      }
      .desc {
        font-size: .6rem;
        font-weight: 400;
        color: #999999;
        margin-top: .1rem;
      }
    }
  }

  .topic_box {
    .game_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: .5rem;
      .name {
        font-size: .7rem;
        font-weight: 500;
        color: #1D1D1D;
        span {
          color: #999999;
        }
      }
      .tag {
        padding: .1rem .3rem;
        background: #FFF0F0;
        border-radius: .2rem;
        font-size: .6rem;
        font-weight: 400;
        color: #FF4B4B;
      }
      .alTag {
        padding: .1rem .3rem;
        background: #F0F7FF;
        border-radius: .2rem;
        font-size: .6rem;
        font-weight: 400;
        color: #3388FF;
      }
    }
    .title {
      font-size: .7rem;
      font-weight: 700;
      color: #1D1D1D;
      margin-bottom: .5rem;
    }
    .desc {
      font-size: .7rem;
      font-weight: 400;
      color: #666666;
      margin-bottom: .5rem;
    }
  }

  .topic_video {
    width: 100%;
    height: 10rem;
    border-radius: .25rem;
    margin-bottom: .5rem;
    overflow: hidden;
    background: #232323;
    position: relative;

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: block;
      pointer-events: none;
      opacity: 0;
      visibility: hidden;
    }

    &.playing {
      video {
        pointer-events: auto;
        opacity: 1;
        visibility: visible;
      }
    }

    .video_img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
    }

    .video_img > * {
      position: relative;
      z-index: 0;
      width: 100%;
      height: 100%;
      display: block;
    }

    ::v-deep .player-wrapper {
      width: 100%;
      height: 100%;
      border-radius: .25rem;
    }

    ::v-deep iframe {
      width: 100%;
      height: 100%;
      border-radius: .25rem;
    }

    .video_img::after {
      content: "";
      width: 100%;
      height: 100%;
      border-radius: .25rem;
      background-color: rgba(35, 35, 35, 0.7);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .video_img::before {
      content: "";
      width: 2rem;
      height: 2rem;
      background-image: url("@/assets/image/shequ/v.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
      border-radius: 50%;
    }
  }

  .tpoic_img {
    margin-top: .6rem;

    .s_image1 {
      width: 100%;
      height: 6rem;
      max-height: 10rem;
    }

    .img_box {
      overflow: hidden;
      display: flex;
    }

    .one {
      .s_image1 {
        width: 100%;
        height: auto !important;
      }

      ::v-deep img {
        border-radius: .25rem;
        max-width: 100%; /* 图片最大宽度不超过容器宽度 */
        height: auto; /* 图片高度自动，保持原有宽高比 */
      }
    }

    .two {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: .3rem;

      .s_image1 {
        &:nth-child(1) {
          ::v-deep img {
            border-radius: .25rem 0rem 0rem .25rem;
          }
        }

        &:nth-child(2) {
          ::v-deep img {
            border-radius: 0rem .25rem .25rem 0rem;
          }
        }
      }
    }
  }

  .three {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: .3rem;

    .s_image1 {
      &:nth-child(1) {
        ::v-deep img {
          border-radius: .25rem 0rem 0rem .25rem;
        }
      }

      &:nth-child(3) {
        ::v-deep img {
          border-radius: 0rem .25rem .25rem 0rem;
        }
      }
    }
  }
}

.topice_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 2.25rem;
    margin-top: .65rem;
    .btn {
      display: flex;
      align-items: center;
      margin-left: 1rem;
      img {
        width: 1rem;
        height: 1rem;
      }
      span {
        font-size: .6rem;
        font-weight: 400;
        color: #999999;
        margin-left: .15rem;
      }
    }
  }
</style>
